import React, {Component} from 'react';
import {images} from 'assets/img/dashboard/home/actions';
import {app} from "app/app";
import {Link} from "react-router-dom";
import 'assets/sass/dashboard/home/Actions.scss';
import {Market} from "buenLib/domain/Market";
import buyIcon from '../../../assets/img/dashboard/home/img/icon-buy.svg';
import sellIcon from '../../../assets/img/dashboard/home/img/icon-sell.svg';
import withdrawIcon from '../../../assets/img/dashboard/home/img/icon-withdraw.svg';
import depositIcon from '../../../assets/img/dashboard/home/img/icon-deposit.svg';
import {ActionButton} from './ActionButton';
import { AppContext } from 'app/state/AppContext';


export class Actions extends Component {
    static contextType = AppContext;

    render() {
        const allRoutes = app.routes();
        return (
            <div className="actions">
                <ActionButton target={allRoutes.dashboard.buyAndSell.homeBuy}
                              icon={<img src={buyIcon} />} label="Comprar"/>
                <ActionButton target={allRoutes.dashboard.buyAndSell.homeSell}
                              icon={<img src={sellIcon} />} label="Vender"/>
                <ActionButton target={allRoutes.dashboard.depositAndWithdraw.homeWithdraw}
                              icon={<img src={withdrawIcon} />} label="Retirar"/>
                <ActionButton target={allRoutes.dashboard.depositAndWithdraw.homeDeposit}
                              icon={<img src={depositIcon} />} label="Ingresar"/>
            </div>
        );
    }

    renderLinksToMarketOperation() {
        const { getCurrencyInstance, marketIdentifiers } = this.context;
        const marketDependentRoutes = app.marketDependentRoutes(marketIdentifiers);
        let links = [];

        marketIdentifiers.forEach((marketIdentifier) => {
            let bidCurrency = Market.bidCurrencyFor(marketIdentifier);
            let askCurrency = Market.askCurrencyFor(marketIdentifier);
            let prettyBidCurrency = getCurrencyInstance(bidCurrency).code();
            let prettyAskCurrency = getCurrencyInstance(askCurrency).code();
            let link = [
                <Link to={marketDependentRoutes.dashboard.buyAndSell[marketIdentifier].buy} key={marketIdentifier}>
                    <div className="action-item">
                        <figure className="icon"><img src={images.buySale} alt={`Compra y venta de ${bidCurrency}`}/>
                        </figure>
                        <h5>{prettyBidCurrency} / {prettyAskCurrency}</h5>
                    </div>
                </Link>];
            links.push(link);
        })
        return links;
    }
}
